import React, { Component } from 'react'
import PropTypes from 'prop-types'
import KeyTakeaway from '../../../components/business/creport/keyTakeaway'
import ReportFiles from '../../../components/business/creport/files'

class BodyCompPreview extends Component {
  static propTypes = {
    report: PropTypes.object,
    dealHtml: PropTypes.func
  }

  render() {
    const { report, dealHtml } = this.props
    return (
      <div className="report-blood-test report-section">
        <h1 className="section-title">2. BODY COMPOSITION</h1>
        <p
          className="text-section"
          dangerouslySetInnerHTML={{
            __html: dealHtml(report.body_comp_intro)
          }}
        />
        <h3 className="section-sub-title">Summary</h3>
        <p
          className="text-section"
          dangerouslySetInnerHTML={{
            __html: dealHtml(report.body_comp_summary)
          }}
        />
        <h3 className="section-sub-title">Key Takeaway</h3>
        {report.body_comp_takeaway && (
          <KeyTakeaway initialValue={report.body_comp_takeaway} />
        )}
        {(report.body_comp_media_files || report.body_comp_media_intro) && (
          <ReportFiles
            readOnly={true}
            files={report.body_comp_media_files || []}
            introduction={report.body_comp_media_intro}
          />
        )}
      </div>
    )
  }
}

export default BodyCompPreview
